import {
  FDVehicle,
  FCVehicle,
  FSVehicle,
  CDVehicle,
  CSVehicle,
  RDVehicle,
  RCVehicle,
  RSVehicle,
  PlaceholderVehicle,
} from "src/assets";
import {
  DataEntryVehicleStepSectionPropsWithStep,
  FormikStep,
  ImpactPoint,
} from "src/types";

export const useVehicleImpactPointsGrid = ({
  step,
  formikFieldBaseName,
  formikVehicleValues,
  formik,
}: DataEntryVehicleStepSectionPropsWithStep) => {
  const VEHICLE_POINTS: Record<ImpactPoint, string> = {
    [ImpactPoint.FRONT_RIGHT]: FDVehicle,

    [ImpactPoint.FRONT_CENTER]: FCVehicle,

    [ImpactPoint.FRONT_LEFT]: FSVehicle,

    [ImpactPoint.CENTER_RIGHT]: CDVehicle,

    [ImpactPoint.CENTER_LEFT]: CSVehicle,

    [ImpactPoint.REAR_RIGHT]: RDVehicle,

    [ImpactPoint.REAR_CENTER]: RCVehicle,

    [ImpactPoint.REAR_LEFT]: RSVehicle,

    [ImpactPoint.PLACEHOLDER]: PlaceholderVehicle
  };

  const GRID_LAYOUT: (ImpactPoint | undefined)[][] = [
    [ImpactPoint.FRONT_LEFT, ImpactPoint.FRONT_CENTER, ImpactPoint.FRONT_RIGHT],
    [ImpactPoint.CENTER_LEFT, ImpactPoint.PLACEHOLDER, ImpactPoint.CENTER_RIGHT],
    [ImpactPoint.REAR_LEFT, ImpactPoint.REAR_CENTER, ImpactPoint.REAR_RIGHT],
  ];

  const fillColor = step == FormikStep.VEHICLE_A ? "#497CB4" : "#FEA600";
  const opacityColor = step == FormikStep.VEHICLE_A ? "#2C72C4" : "#FFCD6D";
  const borderColor = step == FormikStep.VEHICLE_A ? "#9EBEE4" : "#FFCD6D";

  const isPointSelected = (pointId: ImpactPoint): boolean => {
    const isSelected =
      formikVehicleValues.vehicleDamages?.impactPoints?.includes(pointId);

    return isSelected;
  };

  const handlePointClick = (pointId: ImpactPoint) => {
    const impactPoints = formikVehicleValues.vehicleDamages?.impactPoints;
    const isSelected = isPointSelected(pointId);
    const updatedImpactPoints = isSelected
      ? impactPoints.filter((id) => id !== pointId)
      : [...impactPoints, pointId];

    const fieldName = `${formikFieldBaseName}.vehicleDamages.impactPoints`;

    formik.setFieldValue(fieldName, updatedImpactPoints);
  };

  return {
    fillColor,
    opacityColor,
    borderColor,
    VEHICLE_POINTS,
    GRID_LAYOUT,
    handlePointClick,
    isPointSelected,
  };
};
